import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/Header/header";
import Footer from "../../components/Footer/Footer";
import "./Createuser.css";
import "../../assets/backImage.jpeg";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createUser } from "../../slices/userSlice";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { confirmToast } from "../../components/ConfirmToast/ConfirmToast";
import { MultiSelect } from "primereact/multiselect";

// Validation schema using Yup
const validationSchema = Yup.object({
  username: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
  companyName: Yup.string().required("Company name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  admin: Yup.string().required("Role is required"),
  multiVtr: Yup.array().of(Yup.string()).when("admin", {
    is: "subAdmin",
    then: (schema) => schema.min(1, "At least one VTR is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});


const CreateUser = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [signUpLoading, setSignUpLoading] = useState(false)
  //  for emails
  const [email, setEmail] = useState("");
  const [originalEmails, setOriginalEmails] = useState([]);
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [emailStatus, setEmailStatus] = useState(false);
  const [highlightIndex, setHighlightIndex] = useState(-1);
  const itemRefs = useRef([]);
  //for vtr
  const [originalVtrs, setOriginalVtrs] = useState([]);
  const [filteredVtrs, setFilteredVtrs] = useState([]);
  const [VTR, setVTR] = useState(""); // Local state for email
  const [showVtrSuggestions, setShowVtrSuggestions] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState("bottom");
  const [vtrsLoaded, setVtrsLoaded] = useState(false);
  // 
  const suggestionRef = useRef(null);
  const suggestionVtrRef = useRef(null);
  const token = localStorage.getItem("authToken")
  const [storeValueCheckBoxes, setStorevalueCheckBoxes] = useState({
    information: false,
    customerSummary: true,
    vkPlanning: false,
    ekPlanning: false,
    template: false,
    createUser: false,
    modifyUser: false,
  })
  // console.log("storeValueCheckBoxes", storeValueCheckBoxes)

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const { isAuthenticated, user } = useSelector((state) => state.auth);
  // console.log('isAdu ticated? ', isAuthenticated);
  // console.log('user details', user)

  // Initial form values
  const initialValues = {
    username: "",
    password: "",
    companyName: "Lerros",
    email: "",
    admin: "",
    subAdmin: false,
    multiVtr: [],
  };

  const dispatch = useDispatch();

  const handleSubmit = async (values, { resetForm }) => {
    const confirmed = await confirmToast(
      <>
        Are you sure&nbsp;?<br />
        Do you want to create the user&nbsp;?
      </>
    );
    if (!confirmed) return;
    if (values.admin === "subAdmin") {
      values.subAdmin = true;
      values.admin = false;
    }

    if (!confirmed) return;

    await submitForm(values, resetForm);


  };

  // Separate function for actual form submission
  const submitForm = async (values, resetForm) => {
    // console.log("submitValue",values,storeValueCheckBoxes)
    // return
    setSignUpLoading(true)
    try {
      const payload = {
        ...values,
        ...storeValueCheckBoxes, // your checkbox values
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_LINK}/api/v1/admin/createUser`,
        payload, // multiVtr will be ["1", "2"] automatically
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // console.log("payload", payload)

      toast.success("Created successfully! 🎉", { position: "top-right", autoClose: 4000 });
      resetForm();
      setStorevalueCheckBoxes({
        information: false,
        customerSummary: true,
        vkPlanning: false,
        template: false,
        createUser: false,
        modifyUser: false,
      });
    } catch (error) {
      toast.error(`Oops! ${error.response.data.error} 😢`, { position: "bottom-right", autoClose: 4000 });
    } finally {
      setSignUpLoading(false)
    }
  };



  // Function to fetch email data from API on focus
  const fetchEmails = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_LINK}/api/v1/admin/uniqueEmail`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log("response", response)
      setOriginalEmails(response.data.emails || []);
      setFilteredEmails(response.data.emails || []);
      setShowSuggestions(true);
    } catch (error) {
      console.error("Error fetching emails:", error);
    }
  };

  const checkEmailSuggestion = () => {
    setEmailStatus((pre) => !pre)
    // console.log("emailStatus>>>", emailStatus)
  }
  

  useEffect(() => {
    if (emailStatus) {
      fetchEmails();
    }
  }, [emailStatus]);

  const handleKeyDown = (e, setFieldValue) => {
    if (!showSuggestions || filteredEmails.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightIndex((prev) => {
        const next = prev < filteredEmails.length - 1 ? prev + 1 : prev;
        itemRefs.current[next]?.scrollIntoView({ block: "nearest" });
        return next;
      });
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightIndex((prev) => {
        const next = prev > 0 ? prev - 1 : 0;
        itemRefs.current[next]?.scrollIntoView({ block: "nearest" });
        return next;
      });
    }

    if (e.key === "Enter") {
      e.preventDefault();
      if (highlightIndex >= 0) {
        handleSelectEmail(filteredEmails[highlightIndex], setFieldValue);
        setHighlightIndex(-1);
      }
    }
  };;


  // for Vtr function code 

  const fetchVtrs = async () => {
    if (vtrsLoaded) return; //  If it’s already loaded, then don’t call the API again.

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_LINK}/api/v1/admin/getAllVtr`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log("response",response)
      setOriginalVtrs(response.data.vtrs || []);
      setFilteredVtrs(response.data.vtrs || []);
      setShowVtrSuggestions(true);
      setVtrsLoaded(true); //  mark as loaded
    } catch (error) {
      console.error("Error fetching VTRs:", error);
    }
  };

  // Select VTR from Suggestions
  const handleSelectVTR = (selected, setFieldValue) => {
    setVTR(selected);               // for suggestions
    setFieldValue("multiVtr", selected); // updates Formik field correctly
    setShowVtrSuggestions(false);
  };


  const handleVTRChange = (e) => {
    const value = e.target.value.trim();

    setVTR(value);

    if (!Array.isArray(originalVtrs)) return;

    if (value === "") {
      setFilteredVtrs(originalVtrs);
    } else {
      const filtered = originalVtrs.filter(item =>
        item.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredVtrs(filtered);
    }
    setShowVtrSuggestions(true);
  };



  const handleVtrFocus = (e) => {
    const inputRect = e.target.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const spaceBelow = viewportHeight - inputRect.bottom;
    const spaceAbove = inputRect.top;

    // Agar neeche kam jagah aur upar jyada jagah hai
    if (spaceBelow < 250 && spaceAbove > spaceBelow) {
      setDropdownPosition("top");
    } else {
      setDropdownPosition("bottom");
    }
  };




  // Select Email from Suggestions
  const handleSelectEmail = (selectedEmail, setFieldValue) => {
    setEmail(selectedEmail);
    setFieldValue("email", selectedEmail);
    setShowSuggestions(false);
  };


  const handleEmailChange = (e, setFieldValue) => {
    const value = e.target.value.trim();


    // Check if value is 'd'
    // console.log("Typed Value:", value);
    // console.log("Original Emails Before Filtering:", originalEmails);


    if (!Array.isArray(originalEmails)) {
      // console.error("originalEmails is NOT an array:", originalEmails);
      return;
    }


    setEmail(value);
    setFieldValue("email", value);


    if (value === "") {
      setFilteredEmails(originalEmails);
    } else {
      const filtered = originalEmails.filter(email => {
        return email.toLowerCase().includes(value.toLowerCase());
      });


      // console.log("Filtered Emails:", filtered); // Debugging


      setFilteredEmails(filtered);
    }


    setShowSuggestions(true);
  };


  // Hide dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      // for email
      if (suggestionRef.current && !suggestionRef.current.contains(event.target)) {
        setShowSuggestions(false);

      }
      // for Vtr
      if (suggestionVtrRef.current && !suggestionVtrRef.current.contains(event.target)) {
        setShowVtrSuggestions(false)
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);



  const getCheckValue = (e) => {
    const { name, checked } = e.target;
    console.log(name, checked);

    setStorevalueCheckBoxes((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };


  const handleRoleChange = (e, setFieldValue) => {
    const role = e.target.value;
    setFieldValue("admin", role);

    // ADMIN
    if (role === "1") {
      setStorevalueCheckBoxes({
        information: true,
        customerSummary: true,
        vkPlanning: true,
        ekPlanning: true,
        template: true,
        createUser: true,
        modifyUser: true,
      });
    }

    // USER
    if (role === "0") {
      setStorevalueCheckBoxes({
        information: false,
        customerSummary: true,
        vkPlanning: true,
        ekPlanning: true,
        template: true,
        createUser: false,
        modifyUser: false,
      });
    }

    // SUB ADMIN
    if (role === "subAdmin") {
      setStorevalueCheckBoxes({
        information: true,
        customerSummary: true,
        vkPlanning: true,
        ekPlanning: true,
        template: true,
        createUser: false,
        modifyUser: false,
      });
    }
  };




  return (
    <>
      <div>
        <Header />
      </div>
      <div className="main_creatUser">
        <div className="createUser_form">
          {/* heading */}
          <div className="createuser_heading">Sign Up</div>

          {/* Formik Form */}
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, handleReset, setFieldValue, setFieldVTRValue }) => {
              const resetFormValues = () => {
                handleReset();
                setEmail("");
                setVTR("")
                setFilteredEmails([]);
                setFilteredVtrs([])
                setShowSuggestions(false);
                setShowVtrSuggestions(false);
                setStorevalueCheckBoxes({   // reset checkboxes
                  information: false,
                  customerSummary: true,
                  vkPlanning: false,
                  template: false,
                  createUser: false,
                  modifyUser: false,
                });
              };

              // console.log('values check', values)
              return (
                <FormikForm>
                  <div className="createuser_input_main">

                    <div className="input1_main">
                      {/* Username Field */}
                      <div className="input1_username">
                        <Form.Label htmlFor="username" id="creatuser_text">
                          Username<span id="star">*</span>
                        </Form.Label>
                        <Field
                          type="text"
                          id="username"
                          name="username"
                          placeholder="Enter Username"
                          autoComplete="off"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="username"
                          component="div"
                          className="error-text"
                        />
                      </div>

                      {/* Password Field */}
                      <div className="input1_username">
                        <Form.Label htmlFor="password" id="creatuser_text">
                          Password<span id="star">*</span>
                        </Form.Label>
                        <div style={{ position: "relative" }}>
                          <Field
                            type={passwordVisible ? "text" : "password"}
                            id="password"
                            name="password"
                            placeholder="Enter Password"
                            autoComplete="off"
                            className="form-control"
                          />
                          <div
                            id="eye_createuser"
                            onClick={togglePasswordVisibility}
                          >
                            {passwordVisible ? <FaRegEyeSlash /> : <FaRegEye />}
                          </div>
                        </div>
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="error-text"
                        />
                      </div>
                    </div>

                    <div className="input1_main">
                      {/* Company Name Field */}
                      <div className="input1_username">
                        <Form.Label htmlFor="companyName" id="creatuser_text">
                          Company Name<span id="star">*</span>
                        </Form.Label>
                        <Field
                          type="text"
                          id="companyName"
                          name="companyName"
                          placeholder="Enter CompanyName"
                          autoComplete="off"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="companyName"
                          component="div"
                          className="error-text"
                        />
                      </div>

                      {/* Email Field */}


                      {/* Email New Field */}
                      <div className="input1_username" style={{ position: "relative" }}>
                        <Form.Label
                          // htmlFor="email"
                          id="creatuser_text"
                        >
                          Email Name<span id="star1">*</span>
                        </Form.Label>
                        <Field
                          id="email"
                          name="email"
                          placeholder="Enter Email ID"
                          className="form-control email_input"
                          autoComplete="off"
                          onClick={checkEmailSuggestion}
                          onChange={(e) => handleEmailChange(e, setFieldValue)}
                          onKeyDown={(e) => handleKeyDown(e, setFieldValue)}
                          value={email}
                        />
                        <ErrorMessage name="email" component="div" className="error-text" />
                        {/* Show suggestions */}
                        {showSuggestions && filteredEmails.length > 0 && (
                          <div ref={suggestionRef} className="suggestion_box">
                            <ul className="suggestion_list">
                              <div className={filteredEmails.length > 6 ? "email-main" : "email-mains"}>
                                {filteredEmails.map((item, index) => (
                                  <li
                                    key={index}
                                    ref={(el) => (itemRefs.current[index] = el)}
                                    onClick={() => handleSelectEmail(item, setFieldValue)}
                                    className={`emial_list ${highlightIndex === index ? "active_email" : ""}`}
                                  >
                                    {item}
                                  </li>
                                ))}
                              </div>
                            </ul>
                          </div>
                        )}
                      </div>

                    </div>

                    <div className="input1_main">
                      {/* Role Field */}
                      <div className="input1_username">
                        <Form.Label htmlFor="username" id="creatuser_text">
                          Role<span id="star">*</span>
                        </Form.Label>
                        {/* <Field as="select" id="admin" name="admin" className="form-control role_input" >
                          <option value="" id="placeholder">Select a Role</option>
                          <option value="1" id="placeholder">Admin</option>
                          <option value="0" id="placeholder">User</option>
                          <option value="subAdmin" id="placeholder">Sub Admin</option>
                          {/* <option value="Manager">Manager</option> */}
                        {/* </Field> */}
                        <Field name="admin">
                          {({ field }) => (
                            <select
                              {...field}
                              className="form-control role_input"
                              onChange={(e) => handleRoleChange(e, setFieldValue)}
                            >
                              <option value="">Select a Role</option>
                              <option value="1">Admin</option>
                              <option value="0">User</option>
                              <option value="subAdmin">Sub Admin</option>
                            </select>
                          )}
                        </Field>
                        <ErrorMessage name="admin" component="div" className="error-text" />
                      </div>

                      {/* VTR Field */}
                      {values.admin === "subAdmin" && (
                        <div className="input1_username">
                          <Form.Label htmlFor="vtr" id="creatuser_text">
                            VTR<span id="star">*</span>
                          </Form.Label>
                          <MultiSelect
                            id="multiVtr"
                            name="multiVtr"
                            options={originalVtrs.map(item => ({ label: item, value: item }))}
                            value={values.multiVtr}
                            onChange={(e) => setFieldValue("multiVtr", e.value)}
                            placeholder="Select VTR"
                            // display="chip"
                            filter
                            className=" flex items-center border border-gray-300 rounded-md h-[40px] px-2 form-control custom-multiselect"
                            maxSelectedLabels={4}
                            onFocus={fetchVtrs}
                          />
                          <ErrorMessage name="multiVtr" component="div" className="error-text" />
                        </div>
                      )}
                    </div>


                    <div className="input1_main">
                      <div className="input1_checkbox">
                        {/* Information */}
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="check-information"
                            name="information"
                            checked={storeValueCheckBoxes.information}
                            onChange={getCheckValue}
                          />
                          <label className="form-check-label" htmlFor="check-information">
                            Information
                          </label>
                        </div>

                        {/* VK Planning */}
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="check-vkPlanning"
                            name="vkPlanning"
                            checked={storeValueCheckBoxes.vkPlanning}
                            onChange={getCheckValue}
                          />
                          <label className="form-check-label" htmlFor="check-vkPlanning">
                            VK Planning
                          </label>
                        </div>

                        {/* Template */}
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="check-template"
                            name="template"
                            checked={storeValueCheckBoxes.template}
                            onChange={getCheckValue}
                          />
                          <label className="form-check-label" htmlFor="check-template">
                            Template
                          </label>
                        </div>

                        {/* ModifyUser */}
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="check-modifyUser"
                            name="modifyUser"
                            checked={storeValueCheckBoxes.modifyUser}
                            onChange={getCheckValue}
                          />
                          <label className="form-check-label" htmlFor="check-modifyUser">
                            ModifyUser
                          </label>
                        </div>
                      </div>

                      <div className="input1_checkbox">
                        {/* CustomerSummary */}
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="check-customerSummary"
                            name="customerSummary"
                            // checked={storeValueCheckBoxes.customerSummary}
                            checked={true}
                            onChange={getCheckValue}
                          // disabled
                          />
                          <label className="form-check-label" htmlFor="check-customerSummary">
                            CustomerSummary
                          </label>
                        </div>

                        {/* ekPlanning */}
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="check-ekPlanning"
                            name="ekPlanning"
                            checked={storeValueCheckBoxes.ekPlanning}
                            onChange={getCheckValue}
                          />
                          <label className="form-check-label" htmlFor="check-ekPlanning">
                            EK Planning
                          </label>
                        </div>



                        {/* CreateUser */}
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="check-createUser"
                            name="createUser"
                            checked={storeValueCheckBoxes.createUser}
                            onChange={getCheckValue}
                          />
                          <label className="form-check-label" htmlFor="check-createUser">
                            CreateUser
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>







                  {/* Buttons */}
                  <div className="both_btn">
                    <div className="reset_btn">
                      <button
                        type="button"
                        className="btn btn-danger reset_btn_inside"
                        onClick={resetFormValues}
                      >
                        Reset
                      </button>
                    </div>
                    <div className="sign_btn">
                      <button
                        type="submit"
                        className="btn btn-success reset_btn_inside"
                      >{signUpLoading ? (
                        <div id="loading_both">
                          <i id="spinner" className="fa fa-spinner fa-spin"></i>{" "}
                        </div>
                      ) : (
                        "Signup"
                      )}

                      </button>
                    </div>
                  </div>
                </FormikForm>
              )
            }}
          </Formik>
        </div>
      </div >
      <div>
        <Footer />
      </div>
    </>
  );
};

export default CreateUser;